module.exports = __webpack_public_path__ + "media/images/icons/country_flags/ug-075b777269f70c2480e9f59fa1959dff.svg";